// 获取当前的环境
const CURRENTENV = process.env.NODE_ENV

/**
 * 将对象转为数组
 *
 * @param {*} nodes
 * @returns
 */
function convertToArray(nodes) {
  let arr = null
  // 兼容ie
  try {
    arr = Array.prototype.slice.call(nodes, 0)
    // 因为 slice是 array类的方法
    // 而传进来的参数是一个 DOM对象的数组
    // 所以通过call 方法把 array类的方法放到这个对象里面执行
    // call 的第二个参数是表示向被调用的方法传进参数
    // 这里的0 表示从index为0的地方开始
  } catch (ex) {
    // 出现异常就用最常见的方法处理
    arr = []
    for (let i = 0; i < nodes.length; i++) {
      arr.push(nodes[i])
    }
  }
  return arr
}

/**
 * 通用日志打印
 * @param {*} args 要打印的日志内容
 * @param {string} [logTag='log'] 日志标识,默认为log,warn,error,dir
 */
function jadeLog(args, logTag = 'log') {
  // 统一日志输出控制
  if (CURRENTENV !== 'development') return
  switch (logTag) {
    case 'log':
      console.log(...convertToArray(args))
      break
    case 'warn':
      console.warn(...convertToArray(args))
      break
    case 'error':
      console.error(...convertToArray(args))
      break
    case 'dir':
      console.dir(...convertToArray(args))
      break
  }
}

export default {
  /**
   * 普通日志
   */
  log: function() {
    jadeLog(arguments)
  },
  /**
   * 警告日志
   */
  warn: function() {
    jadeLog(arguments, 'warn')
  },
  /**
   * 错误日志
   */
  error: function() {
    jadeLog(arguments, 'error')
  },
  /**
   * 打印对象
   */
  dir: function() {
    jadeLog(arguments, 'dir')
  }
}
